import React, { useEffect } from "react";
import './About.css';

const About = () => {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []); // Empty dependency array ensures it runs only once on mount

  return (
    <div className="about-page">
      <div className="container">
        <h1>About Zenith World Wide Company</h1>
        
        {/* Logo Watermark */}
        <div className="logo-watermark">
          <img src="/logo.png" alt="Zenith World Wide Logo" className="watermark-logo" />
        </div>
        
        <section className="about-hero">
          <h2>Our Story</h2>
          <p>Founded with a vision to revolutionize industries through innovation and excellence, Zenith World Wide has grown from a small startup to a global leader in our field. Our journey began with a simple belief: that technology and human expertise can work together to create extraordinary solutions.</p>
        </section>

        <section className="mission-vision">
          <div className="mission">
            <h2>Our Mission</h2>
            <p>To deliver exceptional products and services that empower businesses to achieve their full potential while maintaining the highest standards of quality, integrity, and innovation.</p>
          </div>
          <div className="vision">
            <h2>Our Vision</h2>
            <p>To be the world's most trusted partner for businesses seeking innovative solutions, recognized globally for our commitment to excellence and positive impact on industries worldwide.</p>
          </div>
        </section>

        <section className="values">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Innovation</h3>
              <p>We constantly push boundaries and embrace new technologies to stay ahead of the curve.</p>
            </div>
            <div className="value-item">
              <h3>Quality</h3>
              <p>We maintain the highest standards in everything we do, ensuring excellence in every project.</p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p>We conduct business with honesty, transparency, and ethical practices in all our interactions.</p>
            </div>
            <div className="value-item">
              <h3>Collaboration</h3>
              <p>We believe in the power of teamwork and building strong partnerships with our clients.</p>
            </div>
          </div>
        </section>

        <section className="team">
          <h2>Our Team</h2>
          <p>Our diverse team of experts brings together decades of experience across various industries. From engineers and designers to business strategists and customer success specialists, we're united by our passion for delivering exceptional results.</p>
          <p>We invest heavily in our people, providing continuous learning opportunities and fostering an environment where creativity and innovation thrive.</p>
        </section>
      </div>
    </div>
  );
};

export default About;
